var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyzedInfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13763",
    "data-name": "Group 13763",
    transform: "translate(-89.295 -25.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(115.26 48.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M163.46,126.03h-1.568c-4.8,0-11.689,3.243-11.689,8.66a2.547,2.547,0,0,0,2.255,2.8h20.389a2.507,2.507,0,0,0,2.405-2.6v-.217C175.246,129.272,168.358,126.03,163.46,126.03Z",
    transform: "translate(-150.188 -106.203)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M169.881,96.75a5.912,5.912,0,0,0,4.478-1.879,13.289,13.289,0,0,0,2.817-8.558,7.3,7.3,0,1,0-14.608,0,13.659,13.659,0,0,0,2.817,8.66A6.2,6.2,0,0,0,169.881,96.75Z",
    transform: "translate(-157.345 -79.009)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11228",
    "data-name": "Path 11228",
    d: "M127.8,25.99a38,38,0,1,0,38,38A38,38,0,0,0,127.8,25.99ZM127.8,88A24.011,24.011,0,1,1,151.8,63.99,24.015,24.015,0,0,1,127.8,88Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11229",
    "data-name": "Path 11229",
    d: "M166.472,63.99A37.884,37.884,0,0,1,155.34,90.862l-9.892-9.892A24.012,24.012,0,1,0,104.77,60.119L90.965,57.868a38,38,0,0,1,75.507,6.123Z",
    transform: "translate(-0.677)",
    fill: "var(--secondaryColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzedInfIcon);
export default __webpack_public_path__ + "static/media/analyzedInfIcon.259ed08bfe4dd73bd977d82fcabcf387.svg";
export { ForwardRef as ReactComponent };